import React, { FC } from 'react';
import _ from 'lodash';
import { Box, Image, MediaOverlay, Proportion } from '@wix/design-system';
import { MediaSource } from '@wix/ambassador-partners-marketplace-v1-template-listing/types';
import AnimatedPreviewOverlayContent from './AnimatedPreviewOverlayContent';
import CarouselStudioBranding from '@components/Templates/TemplateGallery/CarouselStudioBranding';
import {
  getTemplateGradientBackground,
  GRADIENT_COLORS_COUNT,
} from '@utils/templateUtils';

interface Props {
  imageSource?: string;
  description?: string;
  index: number;
  animatedPreview?: MediaSource;
  hovered?: boolean;
  overlayContent?: React.ReactElement;
  mediaContainerClassName?: string;
}

const TemplateCardImage: FC<Props> = ({
  imageSource,
  description,
  index,
  animatedPreview,
  hovered,
  overlayContent,
  mediaContainerClassName,
}) => {
  const colorIndex = index % GRADIENT_COLORS_COUNT;
  const hasAnimatedPreview = animatedPreview && Boolean(animatedPreview?.url);
  const hasOverlay = Boolean(overlayContent) || hasAnimatedPreview;
  const shouldShowAnimatedPreview = !overlayContent && hasAnimatedPreview;
  const resolvedContent = shouldShowAnimatedPreview ? (
    <AnimatedPreviewOverlayContent animatedPreview={animatedPreview} />
  ) : (
    overlayContent
  );

  return (
    <div
      style={{
        position: 'relative',
        height: '100%',
        overflow: 'hidden',
      }}
    >
      <MediaOverlay
        hoverSkin="dark"
        hovered={hovered}
        borderRadius="4px"
        media={
          <Box
            height="100%"
            position="relative"
            padding="18px 18px 0px 18px"
            background={getTemplateGradientBackground(colorIndex)}
            className={mediaContainerClassName ?? ''}
          >
            <Proportion aspectRatio={0.9}>
              <Box>
                <Image
                  src={imageSource}
                  alt={description || 'template image'}
                  borderRadius="3px 3px 0px 0px"
                  fit="cover"
                  style={{ display: 'block' }}
                />
              </Box>
            </Proportion>
          </Box>
        }
      >
        {hasOverlay && (
          <MediaOverlay.Content visible="hover" placement="middle">
            {resolvedContent}
          </MediaOverlay.Content>
        )}
      </MediaOverlay>
      <CarouselStudioBranding isMobileView={false} />
    </div>
  );
};

export default TemplateCardImage;
